type ClassValue = string | undefined | null | false;

export const cx = (...classes: ClassValue[]): string =>
  classes.filter((c): c is string => typeof c === "string" && c.length > 0).join(" ");
